<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <span class="wy-page-section-tooltip" :class="className">
    <el-tooltip effect="dark" :popper-class="'wy-page-tooltip-popup '+className" placement="bottom">
      <div slot="content"><span v-html="tooltipsContent"></span></div>
      <img class="info-icon" src="../../assets/icons/icon_info.svg">
    </el-tooltip>
  </span>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-page-section-tooltip',
  props: ['tooltipsContent', 'className']
});
</script>

<style lang="scss">
.wy-page-section-tooltip {
  .info-icon {
    margin-top: 0px;
    width: 17px;
    position: relative;
    top: 4px;
    cursor: pointer;
  }
}

.wy-page-tooltip-popup {
  max-width: 346px;
}
.wy-page-tooltip-popup.topic-kpi-config {
  max-width: 450px;
  font-size: 13px;
}
</style>